import { TextMultiValuedListMoreItem } from '../../../TextMultiValuedList'

import * as styles from './MoreItem.module.css'

function MoreItem({ display_name: name, ...restProps }) {
  return (
    <TextMultiValuedListMoreItem {...restProps} className={styles.moreItem}>
      {name}
    </TextMultiValuedListMoreItem>
  )
}

export default MoreItem
